import React from 'react';
import { SocialLink } from '../constants/socialLinks';

interface SocialIconProps {
  social: SocialLink;
  className?: string;
}

const SocialIcon: React.FC<SocialIconProps> = ({ social, className = 'w-6 h-6' }) => (
  <svg
    className={`${className} fill-current`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d={social.iconPath} />
  </svg>
);

export default SocialIcon;
